import { render, staticRenderFns } from "./ImageAdmin.vue?vue&type=template&id=338ec5e8&scoped=true"
import script from "./ImageAdmin.js?vue&type=script&lang=js&external"
export * from "./ImageAdmin.js?vue&type=script&lang=js&external"
import style0 from "./ImageAdmin.scss?vue&type=style&index=0&id=338ec5e8&prod&lang=scss&scoped=true&external"
import style1 from "./ImageAdmin.global.scss?vue&type=style&index=1&id=338ec5e8&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "338ec5e8",
  null
  
)

export default component.exports